export interface ICashUpListReport {
  entityName: string;
  entries: ICashUpListEntry[];
}

export interface ICashUpListEntry {
  totalPurchases: number;
  operatorNumber: string;
  operatorName: string;
  operatorUserId: string;
  locationName: string;
  locationId: string;
  openingTime: string;
  closingTime: string;
  openingCash: number;
  closingCash: number;
  totalDeposits: number;
  totalCashIns: number;
  expectedClosingCash: number;
  expectedOpeningCash: number;
  actualClosingCash: number;
  variance: number;
  firstSale: string;
  lastSale: string;
  grandTotalSales: number;
  numberOfSales: number;
  previousClosingCashAmount: number;
  cashInTransit: number;
  totalUnverifiedDeposits: number;
}

export interface ICashUpListTotals {
  totalOpeningCash: number;
  totalActualOpeningCash: number;
  totalActualClosingCash: number;
  totalClosingCash: number;
  totalPurchases: number;
  totalDeposits: number;
  totalCashIns: number;
  totalVariance: number;
  totalGrandTotalSales: number;
  totalUnverifiedDeposits: number;
  totalNumberOfSales: number;
  totalGrandTotalCollections: number;
}
